import { useHistory, useParams } from 'react-router';
import { useGetBusinessQuery } from '../../api/BusinessApi';
import { BusinessHeader } from '../../components/BusinessHeader';
import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { NoResults } from '../../components/NoResults';
import { IconArrowBack, IconBusiness } from '../../components/QuirkIcons';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { QuirkIonPage } from '../../components/QuirkIonPage';
import { QuirkLoader } from '../../components/QuirkLoader';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './AdminBusinessApprovalDetail.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
import { BusinessApprovals } from '../BusinessApprovals.js';
import { BusinessDetails } from '../../components/BusinessDetails.js';
import { SkeletonLoader } from '../../components/SkeletonLoader.js';

export const AdminBusinessApprovalDetail: React.FC = () => {
	const history = useHistory();
	const { businessid } = useParams<{ businessid: string }>();
	const { data: business, isLoading } = useGetBusinessQuery(businessid, { skip: businessid === '' });
	return (
		<QuirkIonPage name="Business Business Approval">
			<Header
				title="Manage Approval"
				left={<IconButton icon={<IconArrowBack />} onClick={() => history.goBack()} />}
			/>
			<QuirkIonContent scroll={true} flush>
				<>
					<QuirkLoader
						isLoading={isLoading}
						loadingMessage={'Loading...'}
						data={business}
						noResults={
							<NoResults
								heading="No claim."
								subheading="Refine or clear your search filters."
								icon={<IconBusiness />}
							/>
						}
					>
						<>
							{business && (
								<div className={styles.claimDetail}>
									<div>
										<SkeletonLoader>
											{business ? (
												<>
													<BusinessHeader business={business} />
													<div className={styles.businessDetails}>
														<BusinessApprovals business={business} />
														<h2>{business.name}</h2>
														<div className={sharedStyles.pageDescription}>
															{business.description}
														</div>
														<BusinessDetails business={business} />
													</div>
												</>
											) : null}
										</SkeletonLoader>
									</div>
								</div>
							)}
						</>
					</QuirkLoader>
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
